/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon24Regular = forwardRef('MediaUiAEjectIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.231 12.938c-.88 1.152-.058 2.812 1.391 2.812h12.756c1.45 0 2.27-1.66 1.391-2.812l-6.378-8.352a1.75 1.75 0 0 0-2.782 0l-6.378 8.352Zm1.391 1.312a.25.25 0 0 1-.199-.402l6.378-8.352a.25.25 0 0 1 .398 0l6.378 8.352a.25.25 0 0 1-.199.402H5.622Z" }),
        React.createElement("path", { d: "M4.5 18.25a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5h-15Z" })));
});
